import { STATUS } from "../../Common/Entity/Enums";

// Selector to get current entity status
export const getSelectedEntityStatus = (state) => {
  const supplier = state.entityReducer.selectedSupplierData;
  if (!supplier) return null;
  const entity = supplier.entity_info?.find(e => e.esi_id === state.entityReducer.selectedEntity)
    ?? supplier.entity_info?.[0];
  return entity?.status || null;
};
export const getSelectedEntityinfo = (state) => {
  const supplier = state.entityReducer.selectedSupplierData;
  if (!supplier) return null;
  const entity = supplier.entity_info?.find(e => e.esi_id === state.entityReducer.selectedEntity)
    ?? supplier.entity_info?.[0];
  return entity || null;
};
export const SET_SUPPLIERS = 'ENTITY/SET_SUPPLIERS';
export const SET_SELECTED_SUPPLIER = 'ENTITY/SET_SELECTED_SUPPLIER';
export const SET_SELECTED_ENTITY = 'ENTITY/SET_SELECTED_ENTITY';
export const SET_LOADING = 'ENTITY/SET_LOADING';
export const SET_ERROR = 'ENTITY/SET_ERROR';
export const CLEAR_ENTITY = 'ENTITY/CLEAR_ENTITY';

const computeShowHistory = (entityInfo, selectedEsiId) => {
  const entity = entityInfo?.find(e => e.esi_id === selectedEsiId) ?? entityInfo?.[0];
  return entity?.status === STATUS.INACTIVE && entity?.has_history === true;
};

const initialState = {
  suppliers: [],
  selectedSupplier: '',
  selectedEntity: '',
  selectedSupplierData: null,
  show_history: false,
  loading: false,
  error: null,
};

const entityReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SUPPLIERS:
      const suppliers = action.payload;
      const firstSupplier = suppliers.length > 0 ? suppliers[0] : null;
      const activeEntitiesForFirst = firstSupplier?.entity_info?.filter(
        e => e.status !== STATUS.PENDING && (e.status !== STATUS.INACTIVE && e.has_history !== false)
      ) || [];
      const firstEntity = activeEntitiesForFirst.length > 0
        ? activeEntitiesForFirst[0]
        : firstSupplier?.entity_info?.[0] || null;
      const selectedSupplierId = state.selectedSupplier || (firstSupplier?.id || '');
      
      return {
        ...state,
        suppliers: suppliers,
        selectedSupplier: selectedSupplierId,
        selectedEntity: state.selectedEntity || (firstEntity?.esi_id || ''),
        selectedSupplierData: suppliers.find(s => s.id === selectedSupplierId) || null,
        show_history: computeShowHistory(
          suppliers.find(s => s.id === selectedSupplierId)?.entity_info,
          state.selectedEntity || (firstEntity?.esi_id || '')
        ),
        loading: false,
        error: null,
      };
    
    case SET_SELECTED_SUPPLIER:
      const selectedSupplierData = state.suppliers.find(s => s.id === action.payload);
      const activeEntitiesForSelected = selectedSupplierData?.entity_info?.filter(
        e => e.status !== STATUS.PENDING && e.status !== STATUS.INACTIVE
      ) || [];
      const firstEntityForSupplier = activeEntitiesForSelected.length > 0
        ? activeEntitiesForSelected[0]
        : selectedSupplierData?.entity_info?.[0] || null;
      
      return {
        ...state,
        selectedSupplier: action.payload,
        selectedSupplierData: selectedSupplierData || null,
        selectedEntity: firstEntityForSupplier?.esi_id || '',
        show_history: computeShowHistory(
          selectedSupplierData?.entity_info,
          firstEntityForSupplier?.esi_id || ''
        ),
      };

    case SET_SELECTED_ENTITY:
      return {
        ...state,
        selectedEntity: action.payload,
        show_history: computeShowHistory(state.selectedSupplierData?.entity_info, action.payload),
      };

    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case CLEAR_ENTITY:
      return initialState;

    default:
      return state;
  }
};

export default entityReducer;
